import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  position: relative;
`;

export const AccountContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const AvatarContainer = styled.div`
  height: 42px;
  width: 42px;

  @media (max-width: 768px) {
    height: 35px;
    width: 35px;
  }
`;

export const IconContainer = styled.div`
  display: flex;

  & svg {
    font-size: 25px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const InfoContainer = styled.div`
  margin: 0 25px 0 10px;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Title = styled.span`
  font-size: 16px;
  font-family: 'Mangueira bold';
  color: ${({ theme }) => theme.colors.blue};
`;

export const Subtitle = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray};
`;

export const DropdownMenu = styled.div`
  width: 150px;
  z-index: 5;
  background: white;
  position: absolute;
  top: 60px;
  right: 0;
  border-radius: 5px;
  box-shadow: 0 0 8px #d8d8d8;
  display: flex;
  gap: 15px;
  padding: 12px;
  flex-direction: column;
`;

export const DropdownItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;

  & svg {
    font-size: 22px;
    color: ${({ theme }) => theme.colors.blue};
  }
`;

export const DropdownText = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray};
  margin-left: 7px;

  ${DropdownItem}:hover & {
    color: ${({ theme }) => theme.colors.blue};
  }
`;
